import { UNRECORDED_ORDERS, PURCHASE_ORDER, PURCHASE_ORDERS } from "../../types";

const PurchasedOrder = (state = {}, action) => {
    if ([UNRECORDED_ORDERS, PURCHASE_ORDER, PURCHASE_ORDERS].includes(action.type)) {
        state = { ...state, [action.type]: action.payload }
    };
    return state;
}

export default PurchasedOrder;